
// README!!!!
// If you want to add a new NPM module to the whole thing to make it
// accessible in your controls and in your individual page JSX you have
// to :
// 1) Install the module in the pipeline folder using npm with --save
// 2) Add the module in the vendorLibs array in the gulpfile.coffee so
// it is included in the browserify process
// 3) Add it to the tsapp object below!

import { runningWithJest } from "./src/logic/util";
import { SalesUrlTrModel } from "./src/types/models/salesurlmodel";
import { TSAPIService } from './src/services/mvcapi';
import { startsWith, trim } from "lodash";

// Plugin name:
const MODS = {
  "react": require('react'),
  "react-dom": require('react-dom'),
  "create-react-class": require('create-react-class'),
  "jquery": require('jquery'),
  "ts-rest-client": require('ts-rest-client'),
  "@tsinternetsale/common": require('@tsinternetsale/common'),
};


// import "../Styles/Style.3.0.scss";
// import "./node_modules/react-calendar/dist/Calendar.css";
// import "./node_modules/yui3-contextual-reset/cssreset-context.min.css";


// @ts-ignore
window.tsapp = {};

// From the ouside, use window.tsapp.init to set it up
window.tsapp.init = function() {
  //const {EMPTY_UUID} =require('./src/logic/util');
  const services = require('./src/services');
  const controls = require('./jsxctl');
  const {
    tsapp
  } = window;
  tsapp.currentLocal = 'fr';
  tsapp.currentCurrency = 'CAD';
  //tsapp.emptyuuid = '00000000-0000-0000-0000-000000000000';
  tsapp.siteSettings = null;
  
  require('react').createClass = require('create-react-class'); // Compat mode
  require('react').PropTypes = require('prop-types'); // Compat mode
  //tsapp._ = require('lodash');

  // Globals
  window.jQuery = require("jquery"); // Expose jQuery
  window.$ = require("jquery"); // Expose jQuery
  require('bootstrap'); // DOIT ÊTRE PLACER ICI car necessite que jQuery soit exposé dans window.

  let langUtil = require('ts-translate-js').util;

  // React
  // window.React = From CDN # require 'react'
  // Super class name helper
  // window.classNames From CDN # = require 'classnames'
  // Ruby like js translation tool
  // tsapp.React = require('react');
  // tsapp.ReactDOM = require('react-dom');

  // React 16 compat mode
  require('react').createClass = require('create-react-class');
  require('react').PropTypes = require('prop-types');

  // From ../Script/ts.coffee, processed and copied in services by gulp
  //tsapp.mvcapiservice = TSAPIService;
  tsapp.mvcapi = null;

  /**
   * Accessing the REST API by the legacy serveur is mainly used to access
   * venue cache so we don't load them twice in RAM
   * @returns 
   */
  tsapp.getRESTAPIThroughLegacyUrl = () => { return tsapp.mvcapi.ctlBaseURL + "/../data"; } // ../ is for removing the ctl/ at the end. 


  //tsapp.up = require('react-addons-update'); // Update immutable objects
  const CounterPart = require('counterpart');

  const trMan = require('ts-translate-js').default;
  //tsapp.tr = tsapp.CounterPart

  // Inclure Moment.js
  const Moment = require('moment');
  require('moment/locale/fr');
  require('moment-timezone');

  // Makes counterpart work as a react component "<Translate...>"
  // tsapp.Translate = require('react-translate-component');
  //tsapp.Tooltip = require('react-tooltip');
  //tsapp.ClickOutsideMixins = require('react-onclickoutside');
  //tsapp.Tran = tsapp.Translate;

  // Translation
  if(!runningWithJest()) {
    trMan.registerDict('fr-CA', require('./_build/lang/fr/strings'));
    trMan.registerDict('en-CA', require('./_build/lang/en/strings'));
  }

  // Common controls!
  tsapp.ctl = controls;
  tsapp.svc = services;
  tsapp.clientTracking = require('./js/client-tracking');

  // tsapp.classNames = require('classnames');

  // Init the api according to the correct mvc ctl path
  tsapp.initmvcapi = (ctlBaseUrl, authTokenStamp) => tsapp.mvcapi = new TSAPIService(ctlBaseUrl, authTokenStamp);
    
  langUtil = require('ts-translate-js').util;

  tsapp.setLocale = function(lang) {
    CounterPart.setLocale(lang);
    tsapp.currentLocal = lang;
    tsapp.twoLetterLang = langUtil.parseLang(tsapp.currentLocal);
    trMan.setLocale(lang);
    const translator = trMan.getCurrentLocaleTR();
    translator.logMissing = false; // Set this on when debugging
    tsapp.tr = translator.boundTR;
    tsapp.trN = tsapp.tr; // This is for the xgettext parser so it can understand very well the difference between a two-plural form call
    Moment.locale(lang);
    tsapp._resetAccountingSettings();
  };


  // Currency
  const accounting = require('accounting');

  tsapp.currencySymbols = {
    fr: {
      CAD: '$ CA',
      USD: '$ US'
    },
    en: {
      CAD: 'CA$ ',
      USD: 'US$ '
    }
  };

  tsapp.currencyFormats = {
    fr: {
      format: '%v %s',
      decSep: ','
    },
    en: {
      format: '%s%v',
      decSep: '.'
    }
  };

  tsapp.shopBasePath = null;

  // Just a little thing to get the symbole part when they are seperated from the number in the UI
  tsapp.BEFORE_CURRENCY_REGEX = /^(.*)%v.*$/;
  tsapp.AFTER_CURRENCY_REGEX = /^.*%v(.*)$/;
  tsapp.getCurrencySurrounding = function() {
    const curSymbol = tsapp.currencySymbols[tsapp.twoLetterLang][tsapp.currentCurrency];
    const curFormat = tsapp.currencyFormats[tsapp.twoLetterLang].format;
    return {
      before: tsapp.BEFORE_CURRENCY_REGEX.exec(curFormat)[1].replace('%s', curSymbol),
      after: tsapp.AFTER_CURRENCY_REGEX.exec(curFormat)[1].replace('%s', curSymbol)
    };
  };

  tsapp.setCurrency = function(lang) {
    tsapp.currentCurrency = lang;
    return tsapp._resetAccountingSettings();
  };

  tsapp._resetAccountingSettings = function() {
    accounting.settings.currency.symbol = tsapp.currencySymbols[tsapp.twoLetterLang][tsapp.currentCurrency];
    accounting.settings.currency.format = tsapp.currencyFormats[tsapp.twoLetterLang].format;
    accounting.settings.currency.decimal = tsapp.currencyFormats[tsapp.twoLetterLang].decSep;
  };

  // Defaults
  tsapp.setLocale('fr');
  tsapp.setCurrency('CAD');


  tsapp.integrationEventsEmitter = null;
  const ee = require('event-emitter');

  const EmitterClass = function() {
    /* .. */
  };

  ee(EmitterClass.prototype);
  tsapp.integrationEventsEmitter = new EmitterClass;



  // Some utils
  tsapp.urlsP = {};
  tsapp.getUrlsP = function(integName) {
    if(tsapp.urlsP[integName] === undefined) {
      tsapp.urlsP[integName] = require('ts-rest-client').get("/integration/" + integName + "/urls");
    }
    return tsapp.urlsP[integName];
  };

  tsapp.logout = () => tsapp.mvcapi.postCtl("login/logout");

  tsapp.goToHome = (integName, continueShoppingUrl) => tsapp.getUrlsP(integName).then(function(urls) {
    if(urls.HomeUrl !== null && !tsapp.isShop) {
      parent.location.href = tsapp.templatingLang(urls.HomeUrl);
    } else if((continueShoppingUrl !== undefined) && (continueShoppingUrl !== "")) {
      parent.location.href = tsapp.templatingLang(continueShoppingUrl);
    } else {
      window.location.href = "/home";
    }
    return true;
  });

  tsapp.goToCart = integName => tsapp.getUrlsP(integName).then(function(urls) {
    if(urls.CartUrl !== null) {
      parent.location.href = tsapp.templatingLang(urls.CartUrl);
    } else if (tsapp.isLiteShop) {
      window.location.href = tsapp.shopBasePath + "/cart";
    } else 
      window.location.href = "/cart";
    return true;
  });

  tsapp.goToCheckout = integName => tsapp.getUrlsP(integName).then(function(urls) {
    if(urls.CheckoutUrl !== null) { 
        parent.location.href = tsapp.templatingLang(urls.CheckoutUrl);
    } else if (tsapp.isLiteShop) {
        window.location.href = tsapp.shopBasePath + "/checkout";
    } else
      window.location.href = "/checkout";
    return true;
  });

  tsapp.getHomeUrl = integName => tsapp.getUrlsP(integName).then(urls => tsapp.templatingLang(urls.HomeUrl));

  tsapp.getCartUrl = integName => tsapp.getUrlsP(integName).then(urls => tsapp.templatingLang(urls.CartUrl));

  tsapp.getPurchaseUrl = integName => tsapp.getUrlsP(integName).then(urls => tsapp.templatingLang(urls.PurchaseUrl));

  // TS Bug Fix : PackageUrl existe pas dans les urls
  // tsapp.getPackageUrl = integName => tsapp.getUrlsP(integName).then(urls => tsapp.templatingLang(urls.PackageUrl));

  tsapp.templatingLang = function(url: string): string {
    if(url == null)
      return null;

    let retUrl: string;
    
    // If not a simple string, fr|en reading
    if(startsWith(trim(url), "{")) {
      let urlObj: SalesUrlTrModel = JSON.parse(url);

      retUrl = urlObj[tsapp.twoLetterLang]; // Take it according to the user's language
      if(retUrl == null)
        retUrl = urlObj["fr"]; // Try french, our default language
      if(retUrl == null)
        retUrl = urlObj[Object.keys(urlObj)[0]]; // Take the first entry
      
    } else 
      retUrl = url as string;

    // Templating...
    if(retUrl != null)
      retUrl = retUrl.replace("{lang}", tsapp.twoLetterLang);
    
    return retUrl;
  };

  // Toastr options
  const toastr = require('toastr');
  toastr.options = {
      timeOut: 7000
  };

  // Page modules are now included in the app
  tsapp.BuyPackageOnePagerWidget = require("./src/components/pages/widgets").BuyPackageOnePagerWidget;
  // tsapp.BuyTicketInProgramWidget = require("./jsx/buyticketinprogram_widget").BuyTicketInProgramWidget;
  tsapp.WidgetAutoLoader = require("./src/components/pages/widgets").WidgetAutoLoader;
  tsapp.BuyTicketOnePagerWidget = require("./src/components/pages/widgets").BuyTicketOnePagerWidget;
  tsapp.CartWidget = require("./jsx/cart_widget").CartWidget;
  tsapp.CartHorizontalStatusWidget = require("./jsx/carthorizontalstatus_widget").CartHorizontalStatusWidget;
  tsapp.ETicketMobilePanel = require("./src/components/organisms/etickets").ETicketMobilePanel;
  tsapp.RenewalActionPanel = require("./src/components/organisms").RenewalActionPanel;
  tsapp.IntegratedRoomWidget = require("./jsx/integratedroom_widget").IntegratedRoomWidget;
  tsapp.OrderValidationWidget = require("./jsx/ordervalidation_widget").OrderValidationWidget;
  tsapp.PaymentMethodList = require("./jsx/payment_method").PaymentMethodList;
  tsapp.SaleQuestionnaireList = require("./jsx/salequestionnairelist").SaleQuestionnaireList;
  tsapp.CartTimer = require("./src/components/molecules/cartstatus/carttimer").CartTimer;

  // Add a require function to tsapp. ESBuild doesnt't support dynamic imports, so we need a require that points to real explicit imports.
  tsapp.require = (moduleName: string) => {
    if(MODS[moduleName]) {
        return MODS[moduleName];
    } else {
        throw new Error(`Module ${moduleName} not found. Check in TSApp.ts -> MODS`);
    }
  };
  
  // @ts-ignore
  window.require = tsapp.require;
};


// Post component CSS
require("./tsapp-post-css-stack.ts");

